import { render, staticRenderFns } from "./TotalWidget.vue?vue&type=template&id=3dcd113a&"
import script from "./TotalWidget.vue?vue&type=script&lang=js&"
export * from "./TotalWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports